// extracted by mini-css-extract-plugin
module.exports = {"root":"BarChart_root___kd_9"};